<ng-container *ngIf="list.length">
  <div
    baseTruncate
    class="{{ firstItemClass }}"
  >
    {{ list[0].name | baseIsEmpty }}
  </div>
  <ng-container *ngIf="list.length > 1">
    <span
      *ngIf="list.length > 1"
      [ngbTooltip]="remainingListTooltip"
      class="align-self-start text-dark-gray {{ plusItemClass }}"
    >
      + {{ list.length - 1 }} {{ 'additional' | translate }}
    </span>
  </ng-container>
</ng-container>

<ng-template #remainingListTooltip>
  <ul class="mb-0 list-unstyled text-start">
    <li *ngFor="let item of list | slice: 1">{{ item.name }}</li>
  </ul>
</ng-template>
